var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "\n   vs-empty-state\n    d-flex justify-content-center align-item-center flex-column text-center\n  "
    },
    [
      _c(
        "div",
        { staticClass: "vs-empty-state__icon w-100" },
        [
          _vm.icon
            ? _c("VsIcon", { attrs: { icon: _vm.icon } })
            : _vm.name
            ? _c("img", {
                attrs: { src: "/images/empty-states/" + _vm.name + ".svg" }
              })
            : _vm.src
            ? _c("img", { attrs: { src: _vm.src } })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "vs-empty-state__text" }, [
        _vm.title
          ? _c("h3", [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")])
          : _vm._e(),
        _vm._v(" "),
        _vm.message
          ? _c("p", [_vm._v("\n      " + _vm._s(_vm.message) + "\n    ")])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }